export default __webpack_public_path__ + "static/media/global_bg2.e887dd6a.png";